import axios from "axios";

const API = axios.create({ baseURL: "https://app-backend-ka51.onrender.com/api/v1" });
// const API = axios.create({ baseURL: "http://localhost:5000/api/v1" });

export const store = "6319a47b3f04f3d828e88388";

API.interceptors.request.use((req) => {
  if (localStorage.getItem("profile")) {
    req.headers.Authorization = `Bearer ${JSON.parse(localStorage.getItem("profile")).token
      }`;
  }

  return req;
});

export const signIn = (formData) => API.post("/users/login", formData);
export const signUp = (formData) => API.post("/users/register", formData);

export const getAllProducts = (store) => API.get(`/products/all/${store}`);
export const getProduct = (id) => API.get(`/products/${id}`);

export const getCategories = (store) => API.get(`/categories/all/${store}`);
export const getCatgory = (id) => API.get(`/categories/${id}`);

export const createOrder = (FormData) => API.post(`/orders`, FormData);
export const getOrder = (orderId) => API.get(`/orders/${orderId}`);
export const getOrders = (userId) => API.get(`/orders/mine/${userId}`);

export const getUsers = (storeId, role) =>
  API.get(`/users/all/${storeId}/${role}`);
export const getUser = (id) => API.get(`/users/${id}`);
export const updateUser = (id, formData) => API.put(`/users/${id}`, formData);

export const getStore = (storeId) => API.get(`/store/${storeId}`);

export const postOrderStripe = (amount, id, description, currency) =>
  API.post(
    `/orders/stripe/create-checkout-session`,
    amount,
    id,
    description,
    currency
  );

export const submitForm = (formData) => API.post(`/contact`, formData);
